<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60 align-items-center justify-content-center">
            <div class="col-md-6 text-center text-white">
              <div class="bg-white rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                style="width:64px;height:64px;">
                <i class="fe fe-user text-dark" style="font-size:1.8rem;"></i>
              </div>
              <div class="h5 mb-2">{{ client.user.full_name }}</div>
              <span v-if="client.user.status == 'active'">
                <span class="badge badge-soft-success px-3 py-2 my-2" style="border-radius:20px;font-size:0.8rem;">
                  <i class="fe fe-check-circle mr-1"></i> Active
                </span>
              </span>
              <span v-else>
                <span class="badge badge-soft-warning px-3 py-2 my-2" style="border-radius:20px;font-size:0.8rem;">
                  <i class="fe fe-alert-circle mr-1"></i> Inactive
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>





      <section class="pull-up">
        <div class="container">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30" v-if="user.type == 'employee'">
                <div class="card-header"></div>

                <div class="card-body">
                  <div class="d-flex flex-wrap align-items-center" style="gap:8px;">
                    <button @click="takePicAndroid" class="btn btn-sm btn-outline-success">
                      <i class="fe fe-camera mr-1"></i> Take Picture
                    </button>

                    <div class="fileinput fileinput-new" data-provides="fileinput">
                      <span class="btn btn-file">
                        <span class="fileinput-new">Upload Picture <i class="fe fe-upload"></i></span>
                        <span class="fileinput-exists">Change</span>
                        <input type="file" name="..." multiple v-on:change="attachPic" />
                      </span>
                      <span class="fileinput-filename"></span>
                      <a href="#" class="close fileinput-exists" data-dismiss="fileinput"
                        style="float: none">&times;</a>
                    </div>

                    <button type="button" @click="changeNumber(client)" class="btn btn-sm btn-info">
                      <i class="fe fe-hash mr-1"></i> Generate ID
                    </button>

                    <router-link :to="{
                        path: '/edit-user/' + $route.params.id,
                        params: {},
                      }">
                      <button class="btn btn-sm btn-outline-dark">
                        <i class="fe fe-edit mr-1"></i> Edit
                      </button>
                    </router-link>

                    <span class="mx-2">
                      <!-- Button trigger modal -->
                      <button type="button" class="btn btn-sm btn-outline-secondary dropdown-toggle"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <i class="fe fe-more-vertical"></i>
                      </button>

                      <div class="dropdown-menu">
                        <router-link :to="{
                            path: '/add-dependent/' + $route.params.id,
                            params: {},
                          }">
                          <div class="ml-3 my-3" role="button">
                            <i class="fe fe-users"></i> Dependents
                          </div>
                        </router-link>

                        <div class="ml-3 my-3" role="button" data-toggle="modal" data-target="#exampleModal">
                          <i class="mdi mdi-credit-card"></i> Add Payment
                        </div>

                        <!-- <div class="ml-3 my-3" role="button" data-toggle="modal" data-target="#exampleModalDocument">
                          <i class="mdi mdi-file"></i> Add Document
                        </div> -->

                        <div class="ml-3 my-3" @click="documentModal = !documentModal" role="button">
                          <i class="mdi mdi-file"></i> Add Document
                        </div>


                        <!-- <router-link :to="{
                            path: '/add-document/' + $route.params.id,
                            params: {},
                          }">
                          <div class="ml-3 my-3" role="button">
                            <i class="fe fe-file"></i> Documents Page
                          </div>
                        </router-link> -->





                        <div class="ml-3 my-3" role="button" data-toggle="modal" data-target="#slideRightModalAll"
                          @click="getActivities">
                          <i class="fe fe-monitor"></i> Activities
                        </div>

                        <a :href="`/patient/${client.user.type}/${$route.params.id}`">
                          <div class="ml-3 my-3" role="button">
                            <i class="mdi mdi-medical-bag"></i> Utilizations
                          </div>
                        </a>

                        <router-link :to="{
                            path: '/client.user/biometrics/' + client.user.id,
                            params: {},
                          }">
                          <div class="ml-3 my-3" role="button">
                            <i class="mdi mdi-hand"></i> Fingerprint
                          </div>
                        </router-link>

                        <a :href="'/enrollee_slip/' + client.user.id">
                          <div class="my-3 ml-3" role="button">
                            <i class="fe fe-printer"></i> Print Slip
                          </div>
                        </a>

                        <a :href="'/id_card/' + client.user.id">
                          <div class="my-3 ml-3" role="button">
                            <i class="fe fe-credit-card"></i> Print ID Card
                          </div>
                        </a>

                        <div v-if="client.user.enabled_user == true" class="ml-3 my-3" role="button"
                          @click="deactivateUser">
                          <i class="fe fe-user-x"></i> Deactivate
                        </div>

                        <div v-else class="ml-3 my-3" role="button" @click="enableUser">
                          <i class="fe fe-check-square"></i> Activate
                        </div>

                        <div class="ml-3 my-3" role="button" @click="deleteUser">
                          <i class="fe fe-delete"></i> Delete
                        </div>

                        <div class="dropdown-divider"></div>
                      </div>

                      <!--Payment Modal -->
                      <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
                        aria-hidden="true">
                        <div class="modal-dialog">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title" id="exampleModalLabel">
                                Add Payment
                              </h5>
                              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                              <input type="text" placeholder="Enter Payment Description" class="form-control my-4"
                                v-model="userPayment.description" />
                              <input type="text" placeholder="Enter Amount" class="form-control"
                                v-model="userPayment.amount" />

                              <input type="date" placeholder="Enter Payment Date" class="form-control my-4"
                                v-model="userPayment.date" />


                              <div class="fileinput fileinput-new" data-provides="fileinput">
                                <span class="btn btn-file">
                                  <span class="fileinput-new">Upload Picture <i class="fe fe-upload"></i></span>
                                  <span class="fileinput-exists">Change</span>
                                  <input type="file" accept="image/png, image/gif, image/jpeg" name="..." multiple
                                    v-on:change="attachPaymentProof" />
                                </span>
                                <span class="fileinput-filename"></span>
                                <a href="#" class="close fileinput-exists" data-dismiss="fileinput"
                                  style="float: none">&times;</a>
                              </div>
                            </div>
                            <div class="modal-footer">
                              <button type="button" class="btn btn-secondary" data-dismiss="modal">
                                Cancel
                              </button>
                              <button type="button" class="btn btn-primary" data-dismiss="modal" @click="addPayment">
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!--End of  Payment Modal -->

                      <!--Document upload Modal -->
                      <b-modal class="modal fade" v-model="documentModal" title="Add Document">
                        <div class="">
                          <div class="">
                            <!-- <div class="modal-header">

                              <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>
                            </div> -->
                            <form @submit.prevent="uploadDocument">
                              <div class="modal-body">
                                <div class="form-group col-md-12">
                                  <label for="inputCity"> Document Type</label>

                                  <v-select v-model="document.name" :options="document_types"></v-select>
                                </div>

                                <div class="form-group col-md-12">
                                  <div class="fileinput fileinput-new" data-provides="fileinput">
                                    <span class="btn btn-file">
                                      <span class="fileinput-new">Upload Document
                                        <i class="fe fe-upload"></i></span>
                                      <span class="fileinput-exists">Change</span>
                                      <input type="file" name="..." v-on:change="attachDocument" />
                                    </span>
                                    <span class="fileinput-filename"></span>
                                    <a href="#" class="close fileinput-exists" data-dismiss="fileinput"
                                      style="float: none">&times;</a>
                                  </div>

                                  <button type="button" @click="takePicAndroidDoc" class="btn btn-outline-info m-2">
                                    Take Picture <i class="fe fe-camera"></i>
                                  </button>
                                </div>


                                <img v-if="imagefile" :src="`${imagefile}`" class="rounded" alt="User Photo" />



                                <button type="submit" class="btn btn-info btn-block mt-3">
                                  Submit
                                </button>
                              </div>
                            </form>


                          </div>
                        </div>
                      </b-modal>
                      <!--End of  Document Upload Modal -->
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-8 col-md-12">
              <div class="card">
                <div class="card-header">
                  <div class="row spacer-top">
                    <div class="col-md-2">
                      <span class="avatar avatar-xl">
                        <img :src="`https://claimify-api.hayokmedicare.ng/image/${agency.user_image}`"
                          class="rounded-circle" />
                      </span>
                    </div>
                    <div class="col-md-10">
                      <strong>
                        <h2 class="h5 text-info text-center">
                          {{ agency.agency_name }}
                        </h2>
                      </strong>
                      <strong>
                        <p class="h5 text-center">
                          ({{ agency.firstname }})
                        </p>
                      </strong>
                    </div>
                  </div>
                </div>

                <div class="card-body row">
                  <div class="col-md-4">
                    <img :src="`${client.user.image_url}`" class="img spacer-top"
                      onerror="this.onerror=null; this.src='/assets/img/ohis_logo.png'" />
                  </div>

                  <div class="col-md-8">
                    <ul class="list-group list-group-flush">
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-user text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Name</p>
                          <p class="font-weight-bold mb-0">{{ client.user.full_name }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-credit-card text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">{{
                            agency.firstname }} ID</p>
                          <p class="font-weight-bold mb-0">{{ client.user.id_card_number }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-calendar text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Expiry Date</p>
                          <p class="font-weight-bold mb-0">{{ client.user.expiry_date | moment("dddd, MMMM Do YYYY") }}
                          </p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start" v-if="client.provider != null">
                        <i class="fe fe-home text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Facility to
                            Access Care</p>
                          <p class="font-weight-bold mb-0">{{ client.provider.agency_name }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start" v-if="client.user.place_of_work">
                        <i class="fe fe-briefcase text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">MDA</p>
                          <p class="font-weight-bold mb-0">{{ client.user.place_of_work }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start" v-if="client.tpa != null">
                        <i class="fe fe-shield text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">HMO</p>
                          <p class="font-weight-bold mb-0">{{ client.tpa.organization_name }}</p>
                        </div>
                      </li>
                      <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-layers text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Sector</p>
                          <p class="font-weight-bold mb-0">{{ client.user.sector }}</p>
                        </div>
                      </li>

                        <li class="list-group-item d-flex align-items-start">
                        <i class="fe fe-layers text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Sector Type</p>
                          <p class="font-weight-bold mb-0">{{ client.user.plan_type }}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div class="">
                <SingleClientDocuments :documents="client.documents" />
              </div>

              <div class="">
                <SingleClientTransactions :transactions="client.transactions" />
              </div>

              <div class="">
                <SingleClientCOF :cofs="client.cofs" />
              </div>
            </div>

            <div class="col-lg-4 col-md-12">
              <div class="card m-b-30">
                <div class="card-header border-bottom">
                  <h6 class="mb-0"><i class="fe fe-info text-info mr-2"></i>Other Details</h6>
                </div>
                <div class="card-body p-0">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-calendar text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Date Enrolled</p>
                        <p class="font-weight-bold mb-0">{{ client.user.created_at | moment("dddd, MMMM Do YYYY") }}</p>
                      </div>
                    </li>
                    <li class="list-group-item" v-for="(dep, index) in dependents" v-bind:key="dep.id">
                      <div class="d-flex align-items-start">
                        <i class="fe fe-users text-info mr-3 mt-1"></i>
                        <div>
                          <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Dependent {{
                            index + 1 }}</p>
                          <p class="font-weight-bold mb-0">{{ dep.firstname }} {{ dep.lastname }}</p>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start" v-if="client.enrolled_by != null">
                      <i class="fe fe-user-check text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Enrolled By</p>
                        <p class="font-weight-bold mb-0">{{ client.enrolled_by.firstname }} {{
                          client.enrolled_by.lastname }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-hash text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">NIMC Number</p>
                        <p class="font-weight-bold mb-0">{{ client.user.nimc_number }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-user text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Gender</p>
                        <p class="font-weight-bold mb-0">{{ client.user.gender }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-heart text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Blood Group</p>
                        <p class="font-weight-bold mb-0">{{ client.user.blood }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-phone text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Phone Number</p>
                        <p class="font-weight-bold mb-0">{{ client.user.phone_number }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-map-pin text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">LGA / Ward</p>
                        <p class="font-weight-bold mb-0">
                          <span v-if="client.local_government != null">{{ client.local_government.local_name }}</span> /
                          <span v-if="client.ward != null">{{ client.ward.ward_name }}</span>
                        </p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-home text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Community</p>
                        <p class="font-weight-bold mb-0">{{ client.user.community }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-gift text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Date of Birth</p>
                        <p class="font-weight-bold mb-0">{{ client.user.dob | moment("D/M/YYYY") }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-mail text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Email</p>
                        <p class="font-weight-bold mb-0">{{ client.user.email }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-clock text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Expiry Date</p>
                        <p class="font-weight-bold mb-0">{{ client.user.expiry_date }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-smile text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Marital Status
                        </p>
                        <p class="font-weight-bold mb-0">{{ client.user.marital_status }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-briefcase text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">MDA</p>
                        <p class="font-weight-bold mb-0">{{ client.user.place_of_work }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-tag text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Previous ID</p>
                        <p class="font-weight-bold mb-0">{{ client.user.virtual_account }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-shield text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Category of
                          Vulnerable Group</p>
                        <p class="font-weight-bold mb-0">{{ client.user.category_of_vulnerable_group }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-credit-card text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Card Issued On
                        </p>
                        <p class="font-weight-bold mb-0">{{ client.user.date_id_card_issued }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-map text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Address</p>
                        <p class="font-weight-bold mb-0">{{ client.user.address1 }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-tool text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Occupation</p>
                        <p class="font-weight-bold mb-0">{{ client.user.occupation }}</p>
                      </div>
                    </li>
                    <li class="list-group-item d-flex align-items-start">
                      <i class="fe fe-book text-info mr-3 mt-1"></i>
                      <div>
                        <p class="text-muted mb-0" style="font-size:0.72rem;text-transform:uppercase;">Education</p>
                        <p class="font-weight-bold mb-0">{{ client.user.education }}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade modal-slide-right" id="slideRightModalAll" tabindex="-1" role="dialog"
          aria-labelledby="slideRightModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header bg-dark text-white align-items-center">
                <div class="d-flex align-items-center">
                  <div class="bg-white rounded-circle mr-3 d-flex align-items-center justify-content-center"
                    style="width:42px;height:42px;flex-shrink:0;">
                    <i class="fe fe-monitor text-dark" style="font-size:1.1rem;"></i>
                  </div>
                  <div>
                    <h5 class="modal-title mb-0" id="slideRightModalLabel">User Activities</h5>
                    <small class="text-white-50">{{ client.user ? client.user.full_name : '' }}</small>
                  </div>
                </div>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div class="modal-body">
                <div class="col-md-12 my-2">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>User</th>
                          <th>Changes</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="activity in activities.data" v-bind:key="activity.id">
                          <td>
                            {{ activity.created_at }}
                            <button type="button" class="btn m-b-15 ml-2 mr-2 badge badge-soft-success">
                              {{ activity.description }}
                            </button>
                          </td>
                          <td>
                            {{ activity.causer.full_name }}
                          </td>

                          <td>
                            <details>
                              <summary>Show/Hide</summary>

                              <span v-for="(value, key) in activity.properties
                                  .attributes" v-bind:key="key">
                                {{ value }},
                              </span>
                            </details>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="container">
                  <div class="row">
                    <div class="col-md-12 m-b-30">
                      <div class="card">
                        <div class="card-header border-bottom"></div>

                        <div class="card-footer row"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-outline-secondary" data-dismiss="modal">
                  <i class="fe fe-x mr-1"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <!--End of Modal -->

        <div class="vld-parent">
          <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";
  // let agency = JSON.parse(localStorage.getItem("agency"));
  import fhis_providers from "@/json/fhis_provider_enrollees.json";
  import fhis_mda from "@/json/fhis_mda.json";
  import users_blood from "@/json/users_blood_group.json";

  import SingleClientDocuments from "./components/SingleClientDocuments";
  import SingleClientTransactions from "./components/SingleClientTransactions.vue";
  import SingleClientCOF from "./components/SingleClientCOF.vue";
  //  import jquery from 'jquery'; 

  export default {
    components: {
      Navbar,
      Loading,
      SingleClientDocuments,
      SingleClientTransactions,
      SingleClientCOF,
    },
    data() {
      return {
        agency: {
          "id": 95930,
          "firstname": "OHIS",
          "agency_name": "Osun Health Insurance Agency",
          "user_image": "1644329032.jpg",
          "state": "2676",
          "localgovt": null,
          "settings": "{\"url\": \"https://portal.fhis.abj.gov.ng\", \"default_hmos\": [59, 29, 60, 27, 61, 30, 35, 31, 34, 28, 32, 26, 33, 25], \"excluded_mdas\": [\"DEACTIVATED GROUPS\", \"DEACTIVATED INDIVIDUAL\", \"IHP ABAJI\", \"IHP AMAC\", \"IHP AMAC PREGNANT WOMEN\", \"IHP GWAGWALADA\", \"IHP KUJE\", \"IHP KWALI\", \"VULNERABLE GROUP (GAC)\", \"VULNERABLE GROUP (KAC)\", \"ABAJI AREA COUNCIL\", \"Abuja Municipal Area Council (AMAC)\", \"BWARI AREA COUNCIL\", \"KWALI AREA COUNCIL\", \"GWAGWALADA AREA COUNCIL\", \"KUJE AREA COUNCIL\", \"LEA ABAJI\", \"LEA AMAC\", \"LEA BWARI\", \"LEA GWAGWALADA\", \"LEA KUJE\", \"LEA KWALI\"], \"primary_color\": null, \"max_dependents\": 5, \"waiting_period\": 60, \"secondary_color\": null, \"auto_approve_cof\": true, \"auto_delete_enrollees\": true, \"cof_document_compulsory\": true, \"max_dependent_child_age\": 21}"
        },
        fhis_providers: fhis_providers,
        fhis_mda: fhis_mda,
        users_blood: users_blood,
        activities: "",
        user: null,
        trx_image: false,
        documentModal: false,
        auth_user: "",
        client: { user: "full_name", transactions: [] },
        document_types: [
          "Registration Form",
          "Revalidation Form",
          "Renewal Receipt",
          "Credential",
          "Change of Facility",
          "Others",
        ],
        trx_doc: null,
        notes: "",
        dependents: "",
        medications: "",
        healthFacility: "",
        signature: "",
        enrolled_by: "",
        singleward: "",
        singlelga: "",
        edit: false,
        isLoading: false,
        fullPage: true,
        transactionID: "",
        agency_id: "",
        imagefile: "",
        image: "",
        paymentProofFile: null,
        paymentProofImage: "",
        output: "",
        singletpa: "",
        trxdocclass: "col-md-4",
        trxtableclass: "col-md-12",
        pictureShower: true,
        userPayment: {
          description: "",
          date: "",
          amount: "",
        },
        document: {
          name: "",
          document: "",
          document_picture: "",
        },
        transaction_ref_length: 50,
      };
    },

    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.client = response.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    computed: {
      randomTransId() {
        var result = "";
        var characters =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        var charactersLength = characters.length;
        for (var i = 0; i < this.transaction_ref_length; i++) {
          result += characters.charAt(
            Math.floor(Math.random() * charactersLength)
          );
        }
        console.log({ result });
        return result;
      },
    },

    methods: {
      addPayment() {
        if (confirm("Are you sure you want to Submit?")) {
          this.isLoading = true;
          this.axios
            .post(`/api/v1/make/transaction`, {
              user_id: this.$route.params.id,
              agency_id: 95930,
              description: this.userPayment.description,
              amount: this.userPayment.amount,
              date: this.userPayment.date,
              type: "offline",
              status: "created",
              transaction_ref: this.randomTransId,
            })
            .then((response) => {
              this.transactionID = response.data.id;
              this.isLoading = false;
              this.$toasted.success("Payment Added Successfully", {
                position: "top-center",
                duration: 3000,
              });
              // this.fetchUser()
            })
            .catch((error) => {
              console.error(error);
              this.isLoading = false;
            });

          this.userPayment.description = "";
          this.userPayment.amount = "";
        }
        if (this.paymentProofFile != null) {
          setTimeout(() => {
            this.uploadPaymentProof();
          }, 3000);
        }


      },

      cleanDBEnrollee(client) {
        //Filter JSON

        //provider
        // let fhis_providers = this.fhis_providers;
        // let formatter = fhis_providers.filter(
        //   (x) => x.id_card_number == client.user.id_card_number
        // );
        // let enrollee_provider = formatter[0];

        // let provider_id =
        //   enrollee_provider == null
        //     ? client.user.provider_id
        //     : enrollee_provider.provider_id;
        // console.log(formatter);

        //mda
        // let fhis_mda = this.fhis_mda;
        // let formatterMDA = fhis_mda.filter(
        //   (x) => x.enrollee_id == client.user.previous_user_id
        // );
        // let enrollee_mda = formatterMDA[0];
        // console.log(formatterMDA);

        //Enrollee Blood users_blood
        //mda
        let users_blood = this.users_blood;
        let formatterBlood = users_blood.filter(
          (x) => x.previous_user_id == client.user.previous_user_id
        );
        let enrollee_blood = formatterBlood[0];
        console.log(formatterBlood);

        //End of Filter JSON

        this.axios
          .patch(`/api/v1/auth/clean-db-enrollee/${this.$route.params.id}`, {
            id_card_number: client.user.id_card_number,
            previous_user_id: client.user.previous_user_id,
            // provider_id: provider_id,
            // previous_alternate_provider_id: enrollee_provider.alternative_hcp_id,
            // previous_mda_id: enrollee_mda.organization_id,
            blood: enrollee_blood.blood_group,
          })
          .then((response) => {
            this.client.provider = response.data.user.userprovider;
            this.client.user.place_of_work = response.data.user.place_of_work;
            this.client.user.documents = response.data.user.documents;
            this.dependents = response.data.user.dependants;
            console.log(JSON.stringify(this.client.provider) + "hellox");
          })
          .catch((error) => {
            console.error(error);
          });
      },
      // User Picture Upload
      attachPic(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        console.log(event);
        this.image = event.target.files[0];
        this.uploadPicture();
      },
      uploadPicture() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));
        var formData = new FormData();
        formData.append("user_image", this.image);
        formData.append("user_id", this.$route.params.id);
        this.axios
          .post("/api/v1/auth/uploadUserImage", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Image added Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
          });
        console.log(this.client);
      },
      // End of Picture Upload

      attachForm(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        console.log(event);
        this.image = event.target.files[0];
        this.uploadPictureForm();
      },
      uploadPictureForm() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));
        var formData = new FormData();
        formData.append("enrollment_form", this.image);
        formData.append("user_id", this.$route.params.id);
        this.axios
          .post("/api/v1/upload-enrollment-form", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Form added Successfully!", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
          });
        console.log(this.client);
      },
      attachPaymentProof(event) {
        this.user = JSON.parse(localStorage.getItem("user"));
        console.log(event);
        this.paymentProofFile = event.target.files[0];
        console.log(this.paymentProofFile);
      },

      uploadPaymentProof() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));

        var formData = new FormData();
        formData.append("transaction_id", this.transactionID);
        formData.append("user_id", this.$route.params.id);
        formData.append("document", this.paymentProofFile);

        this.axios
          .post("/api/v1/auth/uploadTransactionDocument", formData)
          .then((response) => {
            this.paymentProofImage = response.data.document;
            console.log(response.data.document);
            this.isLoading = false;
            this.$toasted.success("Payment Added Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
          });
      },

      async takePicAndroidDoc() {

        this.documentModal = false;

        const image = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
        });

        var imageUrl = image.base64String;
        this.imagefile = "data:image/jpeg;base64," + imageUrl;
        // this.document.document_picture = imageUrl;

        this.documentModal = true;

      },
      attachDocument(event) {
        console.log(event);
        this.document.document = event.target.files[0];
      },

      uploadDocument() {
        this.isLoading = true;
        this.user = JSON.parse(localStorage.getItem("user"));
        var formData = new FormData();
        formData.append("type_id", this.$route.params.id);
        formData.append("user_id", this.$route.params.id);
        formData.append("name", this.document.name);
        formData.append("document", this.document.document);
        formData.append("document_picture", this.imagefile);
        formData.append("type", "enrollee");
        this.axios
          .post("/api/v1/auth/documents", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Document uploaded Successfully", {
              position: "top-center",
              duration: 3000,
            });

            this.fetchUser();

            this.document.name = "";
          })
          .catch((error) => {
            this.$toasted.error("Error Uploading", {
              position: "top-center",
              duration: 3000,
            });
            console.error(error);
            this.isLoading = false;
          });
      },

      async takePicAndroid() {
        const image = await Camera.getPhoto({
          quality: 90,
          allowEditing: false,
          resultType: CameraResultType.Base64,
          source: CameraSource.Camera,
        });

        var imageUrl = image.base64String;
        this.imagefile = "data:image/png;base64," + imageUrl;

        this.savePic();
      },

      savePic() {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/uploadcustomerpicImage`, {
            user_image: this.imagefile,
            user_id: this.$route.params.id,
          })
          .then((response) => {
            console.log(response);
            this.$toasted.success("uploaded Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.fetchUser();
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      },
      deleteUser() {
        if (confirm("Are you Sure you want to delete this user")) {
          this.axios
            .delete(`/api/v1/auth/deleteUser/${this.$route.params.id}`)
            .then((response) => {
              console.log(response);
              this.$router.push("/view-clients-agency");

              this.$toasted.success("Deleted Successfully", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      enableUser() {
        if (confirm("Are you Sure you want to activate?")) {
          this.axios
            .post(`/api/v1/auth/enableUser/` + this.$route.params.id)
            .then(() => {
              this.fetchUser();
              this.$toasted.info("Activated Successfully!", {
                position: "top-center",
                duration: 8000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      deactivateUser() {
        if (confirm("Are you Sure you want to deactivate?")) {
          this.axios
            .post(`/api/v1/auth/disableUser/` + this.$route.params.id)
            .then(() => {
              this.fetchUser();
              this.$toasted.info("Deactivated Successfully!", {
                position: "top-center",
                duration: 8000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      deleteTrx(trx) {
        if (confirm("Are you Sure you want to delete?")) {
          this.axios
            .delete(`/api/v1/auth/delete/transaction/${trx.id}`)
            .then((response) => {
              console.log(response);
              this.fetchUser();
              this.$toasted.success("Deleted Successfully", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
            });
        }
      },

      fetchUser() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
          .then((response) => {
            this.client = response.data;
            this.dependents = response.data.dependents;
            // this.cleanDBEnrollee(this.client);
          })
          .catch((error) => {
            console.error(error);
          });
      },

      uploadPic() {
        this.isLoading = true;
        let snap = localStorage.getItem("snap");

        var formData = new FormData();
        formData.append("user_image", snap);
        this.axios
          .post("/api/v1/auth/uploadUserImage", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$breadstick.notify("Profile Image changed Successfully!", {
              position: "top-right",
            });
            // this.getUser()
          });
      },
      // uploadPaymentProof() {
      //   this.isLoading = true;
      //   let snap = localStorage.getItem("snap");

      //   var formData = new FormData();
      //   formData.append("user_image", snap);
      //   this.axios
      //     .post("/api/v1/auth/uploadUserImage", formData, {
      //       headers: {
      //         "Content-Type": "multipart/form-data",
      //       },
      //     })
      //     .then((response) => {
      //       console.log(response);
      //       this.isLoading = false;
      //       this.$breadstick.notify("Profile Image changed Successfully!", {
      //         position: "top-right",
      //       });
      //       // this.getUser()
      //     });
      // },

      getActivities() {
        this.axios
          .get(`/api/v1/auth/activities-on-user/${this.$route.params.id}`, {
            params: {
              model: "App\\Models\\User",
            },
          })
          .then((response) => {
            this.activities = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      changeNumber() {
        if (confirm("Are you Sure you Want to Change ID?")) {
          this.isLoading = true;
          this.axios
            .patch(
              `/api/v1/auth/id-card-number/change/${this.$route.params.id}`,
              {
                type: "client",
              }
            )
            .then((response) => {
              console.log(response);
              this.isLoading = false;
              this.fetchUser();
              this.$toasted.success("ID Updated Successfully", {
                position: "top-center",
                duration: 3000,
              });
            })
            .catch((error) => {
              console.error(error);
              this.$toasted.error("Not Found!", {
                position: "top-center",
                duration: 3000,
              });
              this.isLoading = false;
            });
        }
      },
    },
    created() {
      this.fetchUser();
    },
  };
</script>

<style>
  #slideRightModalAll {
    position: fixed !important;
  }

  #slideRightModalAll .modal-dialog {
    position: fixed !important;
    top: 0;
    right: 0;
    bottom: 0;
    height: 100vh !important;
    display: flex;
    flex-direction: column;
  }

  #slideRightModalAll .modal-content {
    height: 100vh !important;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  #slideRightModalAll .modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
  }

  #slideRightModalAll .modal-header,
  #slideRightModalAll .modal-footer {
    flex-shrink: 0;
  }
</style>

<style scoped>
  .spacer {
    margin-left: 1px;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .spacer-image {
    margin-top: 25px;
  }

  .spacer-top-bottom {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .spacer-top {
    margin-top: 50px;
  }

  #container {
    margin: 0px auto;
    width: 500px;
    height: 375px;
    border: 10px #333 solid;
  }

  #videoElement {
    width: 500px;
    height: 375px;
    background-color: #666;
  }

  th {
    text-align: center;
  }

  td {
    width: fit-content;
    text-align: center;
  }

  .payment__proof {
    width: 20%;
  }

  .payment__proof,
  svg,
  video,
  canvas,
  audio,
  iframe,
  embed,
  object {
    display: inline-block;
  }
</style>